import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { DialogTitle, DialogContent, Box, Typography } from '@mui/material'

import { TextInput, ThemeButton } from '../../../../ui'

const TEXT_AREA_LENGTH = 250

export const AbortIPDialog = ({ close, submitNonconformity }) => {
  const { formatMessage } = useIntl()

  const [loading, setLoading] = useState(false)
  const [formState, setFormState] = useState({})

  const DIALOG_MESSAGES = {
    title: formatMessage({ id: 'pages.inspections.abortIPDialog.title' }),
    description1: formatMessage({ id: 'pages.inspections.abortIPDialog.description.1' }),
    description2: formatMessage({ id: 'pages.inspections.abortIPDialog.description.2' }),
    buttons: {
      cancel: formatMessage({ id: 'global.cancel' }),
      confirm: formatMessage({ id: 'global.confirm' }),
    },
  }

  const handleChangeForm = (e) => setFormState({ ...formState, [e.target.name]: e.target.value })

  const handleSubmit = () => {
    setLoading(true)
    submitNonconformity(formState)
      .then((callback) => {
        setLoading(false)
        close()
        callback.redirectToTable()
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Box p={2}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography variant="h4" color="primary">
            {DIALOG_MESSAGES.title}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">{DIALOG_MESSAGES.description2}</Typography>
        <Box pt={2}>
          <TextInput
            name="observaciones"
            value={formState.observaciones}
            placeholder={`Máx. ${TEXT_AREA_LENGTH} caracteres`}
            multiline={true}
            onChange={handleChangeForm}
            rows={4}
            rowsMax={4}
            inputProps={{ maxLength: TEXT_AREA_LENGTH }} //En BE no tienen límite de caracteres
          />
        </Box>
        <Box display="flex" justifyContent="space-around" pt={3} flexWrap="wrap">
          <Box width={150} mb={[3, 0]}>
            <ThemeButton onClick={close} color="inherit" disabled={loading} fullWidth>
              {DIALOG_MESSAGES.buttons.cancel}
            </ThemeButton>
          </Box>
          <Box width={150}>
            <ThemeButton
              onClick={handleSubmit}
              color="primary"
              fullWidth
              loading={loading}
              disabled={loading}
            >
              {DIALOG_MESSAGES.buttons.confirm}
            </ThemeButton>
          </Box>
        </Box>
      </DialogContent>
    </Box>
  )
}
